/**
 * Rides Services Module
 * Exports all Rides Management services and the factory function.
 * Backend: CCMS.Api.RidesManagement (servicePath `rides`, gateway prefix `/rides/`).
 */
import { RidesLookupsService } from './RidesLookupsService';
import { RidesMeService } from './RidesMeService';
import { RidesAvailabilityService } from './RidesAvailabilityService';
import { RidesMatchesService } from './RidesMatchesService';
import { RidesBookingsService } from './RidesBookingsService';
import { RidesSecurityService } from './RidesSecurityService';
import { RidesAdminService } from './RidesAdminService';
import { RidesSettingsService } from './RidesSettingsService';
export { RidesLookupsService, RidesMeService, RidesAvailabilityService, RidesMatchesService, RidesBookingsService, RidesSecurityService, RidesAdminService, RidesSettingsService, };
/**
 * Create all Rides Management services with shared configuration.
 */
export function createRidesServices(http, config) {
    return {
        lookups: new RidesLookupsService(http, config),
        me: new RidesMeService(http, config),
        availability: new RidesAvailabilityService(http, config),
        matches: new RidesMatchesService(http, config),
        bookings: new RidesBookingsService(http, config),
        security: new RidesSecurityService(http, config),
        admin: new RidesAdminService(http, config),
        settings: new RidesSettingsService(http, config),
    };
}
//# sourceMappingURL=index.js.map